"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./row-detail.directive"));
__export(require("./row-detail-template.directive"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/@swimlane/ngx-datatable/release/components/row-detail/index.js
// module id = Ysne
// module chunks = 4